import {app} from '../../app';
import 'marked';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import IComponentController = angular.IComponentController;
import {LanguageSharedQuestion} from "../../sharedQuestions/LanguageSharedQuestion";
import {UniqueIdService} from '../../services/UniqueIdService';

export class LanguageQuestionComponent {

    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;
    protected uniqueIdService:UniqueIdService;

    public sharedQuestion: LanguageSharedQuestion;
    public question:IQuestion;
    public value:string;

    static $inject = ['SharedQuestionService', 'SessionService', 'UniqueIdService'];

    chooserId:string;

    constructor(sharedQuestionService:SharedQuestionService, sessionService:ISessionService, uniqueIdService:UniqueIdService) {
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService = sessionService;
        this.uniqueIdService = uniqueIdService;
    }

    public $onInit = () => {
        this.sharedQuestion = new LanguageSharedQuestion();
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        this.chooserId = this.uniqueIdService.getUniqueId('language-chooser');
    };

}

app.component('languageQuestion', {
    templateUrl: 'templates/components/questionTypes/languageQuestion.html',
    controller: LanguageQuestionComponent,
    controllerAs: 'language',
    bindings: {
        question: '<',
        nextQuestionCallback: '&'
    }
});